// extracted by mini-css-extract-plugin
export var container = "_3q-0";
export var containerTopRight = "_3q-1";